import React, { useCallback } from 'react';
import { UilCopy } from '@iconscout/react-unicons';
import { IconButton } from '@chakra-ui/react';
import { findCompByIdRecursively, fixIndexes } from '../../../utils/functions';

import { selectComponent } from '../../../redux/selectedComponentSlice';
import { updatePages } from '../../../redux/pagesSlice';

import { useDispatch } from 'react-redux';

const DuplicateComponent = ({ pages, selectedPageValue, componentId, selectedComponentPropsValue }) => {
	const dispatch = useDispatch();

	const handleClick = useCallback(() => {
		const newPages = JSON.parse(JSON.stringify(pages));
		const pageIndex = newPages.findIndex((page) => page.pageId == selectedPageValue);
		const page = newPages[pageIndex];
		const { parentArray, comp } = findCompByIdRecursively(page.pageData, componentId);
		const duplicatedComp = JSON.parse(JSON.stringify(comp));
		const foundIndex = parentArray.findIndex((comp) => comp.componentId == componentId);
		const moveTo = parentArray[foundIndex]?.moveTo;
		// parentArray.splice(foundIndex, 1);
		//add duplicatedComp after foundIndex
		parentArray.splice(foundIndex + 1, 0, duplicatedComp);
		if (moveTo) {
			fixIndexes(page, foundIndex, moveTo);
		}
		dispatch(updatePages(newPages));
		//
		if (selectedComponentPropsValue.componentId == componentId) {
			dispatch(selectComponent(null));
		}
	}, []);

	return (
		<IconButton
			key={'icon-button-3'}
			bg={'white'}
			onClick={handleClick}
			variant="outline"
			size={'sm'}
			aria-label="Duplicar componente"
			icon={<UilCopy size={18} />}
		/>
	);
};

export default DuplicateComponent;
